import React, { useEffect, useRef } from 'react';
import PropTypes from 'prop-types';
import { useDispatch } from 'react-redux';
import { DefaultButton } from 'common/components';
import { acceptError } from 'common/_redux';

const PayOnUsWidgetButton = ({ config }) => {
  const dispatch = useDispatch();

  const iframeRef = useRef(null);

  useEffect(() => {
    const iframeMessageHandler = event => {
      if (!event.data) {
        return;
      }

      if (event.data.type === 'PAYONUS_CLOSE') {
        if (iframeRef.current) {
          iframeRef.current.remove();
          iframeRef.current = null;
        }
      }

      if (event.data.type === 'PAYONUS_ERROR') {
        const message = event.data.message || 'Failed to open the payment form';

        dispatch(acceptError(message, true));

        if (iframeRef.current) {
          iframeRef.current.remove();
          iframeRef.current = null;
        }
      }
    };

    window.addEventListener('message', iframeMessageHandler);

    return () => {
      window.removeEventListener('message', iframeMessageHandler);
    };
  }, [dispatch]);

  const handleButtonClick = () => {
    try {
      const iframe = document.createElement('iframe');
      iframeRef.current = iframe;

      iframe.style.position = 'fixed';
      iframe.style.top = '0';
      iframe.style.left = '0';
      iframe.style.width = '100vw';
      iframe.style.height = '100vh';
      iframe.style.border = 'none';
      iframe.style.zIndex = '999999';

      document.body.appendChild(iframe);

      const iframeContentDocument = iframe.contentDocument;

      if (!iframeContentDocument) {
        throw new Error('Iframe not available');
      }

      iframeContentDocument.open();
      iframeContentDocument.write(`
        <!DOCTYPE html>
        <html>
          <head>
            <meta charset="utf-8" />
            <script src="https://payonus.com/checkout-v2.min.js"></script>
          </head>
          <body>
            <script>
              function notify(type, payload) {
                parent.postMessage(Object.assign({ type: type }, payload || {}), '*');
              }

              const widgetConfig = ${JSON.stringify(config)};

              window.onload = function () {
                try {
                  if (!window.OnUsCheckout) {
                    throw new Error('SDK not loaded');
                  }

                  window.OnUsCheckout.init();

                  window.OnUsCheckout.checkout({
                    ...widgetConfig,

                    onClose: function () {
                      notify('PAYONUS_CLOSE');
                    },

                    onError: function (error) {
                      notify('PAYONUS_ERROR', {
                        message: error && error.message
                          ? error.message
                          : 'Payment failed'
                      });
                    }
                  });

                } catch (e) {
                  notify('PAYONUS_ERROR', { message: e.message });
                }
              };
            </script>
          </body>
        </html>
      `);
      iframeContentDocument.close();
    } catch (e) {
      const errorMessage = e.message || 'Failed to open the payment form';

      dispatch(acceptError(errorMessage, true));
    }
  };

  return <DefaultButton type="button" textId="continueRequest" filled onClick={handleButtonClick} />;
};

PayOnUsWidgetButton.propTypes = {
  config: PropTypes.object.isRequired,
};

export default PayOnUsWidgetButton;
